import React, { useId } from 'react'
const Breadcrumbs = (props) => {
    let urldata = []
    const id =useId()
    props.history.location && props.history.location.pathname && props.history.location.pathname.split("/").forEach(function (i) {
        urldata.push(!i ? 'home' : i)
    });

    const handleBreadcrumbLink = (e, pagename) => {
        e && e.preventDefault()
        props.handlePageRoute(pagename)
    }
    return (
        <div className="main-container">
            <div className="breadcrumb text-left py-2">
                <p data-font-size-mo="12" data-font-size-pc="14">
                    {urldata && urldata.length > 0 && urldata.map((item, i) => {
                        return <>
                            <a key={id} href="" className={`color-5b ${i + 1 == urldata.length ? '' : 'font-600'}`} style={{ textTransform: "capitalize", pointerEvents: i + 1 == urldata.length ? 'none' : '' }} onClick={e => i + 1 == urldata.length ? e.preventDefault() : handleBreadcrumbLink(e, item)}>{item}</a>
                            {i + 1 == urldata.length ? '' : ' > '}
                        </>
                    })}
                </p>
            </div>
        </div>
    )
}

export default Breadcrumbs